module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    class: {
      'no-sidebar': !_vm.showSidebar
    }
  }, [(!_vm.isMobile && !_vm.config.disableSidebarToggle) ? _c('sidebar-toggle') : _vm._e(), _vm._v(" "), (_vm.loaded && (_vm.showSidebar || _vm.isMobile)) ? _c('figure', {
    ref: "sidebar",
    staticClass: "sidebar"
  }, [(_vm.pluginSearch) ? _c('search-box') : _vm._e(), _vm._v(" "), (_vm.pluginSearch && _vm.searchResult && _vm.searchKeyword) ? _c('search-result') : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('custom-components', {
    attrs: {
      "place": "sidebar:start"
    }
  }) : _vm._e(), _vm._v(" "), _c('header-nav', {
    staticClass: "is-mobile inner-x",
    attrs: {
      "has-nav": _vm.hasNav,
      "show-nav": _vm.showNav,
      "current-nav": _vm.currentNav
    }
  }), _vm._v(" "), (_vm.showToc) ? _c('toc', {
    attrs: {
      "headings": _vm.page.headings
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('custom-components', {
    attrs: {
      "place": "sidebar:end"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('mobile-header', {
    attrs: {
      "current-icons": _vm.currentIcons
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "main"
  }, [(_vm.loaded) ? _c('home-header', {
    attrs: {
      "current-icons": _vm.currentIcons,
      "has-nav": _vm.hasNav,
      "show-nav": _vm.showNav
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('custom-components', {
    attrs: {
      "place": "content:start"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.docComponent) ? _c(_vm.docComponent, {
    tag: "component"
  }) : _c('div', {
    staticClass: "markdown-body content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.html)
    }
  }), _vm._v(" "), (_vm.loaded) ? _c('custom-components', {
    attrs: {
      "place": "content:end"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-dfaeea44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Page.vue
// module id = 107
// module chunks = 0